import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { usePermissions } from '../../hooks/Authentication/usePermissions'
import AddPermission from './AddPermission'

export default function EditPermission() {
  const { getPermission, permission, loading } = usePermissions()
  const params = useParams()
  // debapiugger
  useEffect(() => {
    console.log({params})
    getPermission({ permissionId: params.permissionId })
  }, [params.permissionId])

  return <> {loading ? <Loader /> : <AddPermission permission={permission} />} </>
}
